import { render } from "./Home-page.vue?vue&type=template&id=8578ee16"
import script from "./Home-page.vue?vue&type=script&lang=js"
export * from "./Home-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__